import { SC } from "../../styles/theme";

export default function Badge({ v }) {
  const sc = SC[v] || { bg: "#e5e7eb", c: "#374151" };
  return (
    <span style={{ background: sc.bg, color: sc.c, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, textTransform: "capitalize", whiteSpace: "nowrap" }}>
      {v}
    </span>
  );
}
